module.exports = __webpack_public_path__ + "static/media/Icon-tire-blue.17e42eb7.svg";